export const SPEC_ORDER = {
    high_current_device: [
        'device',
        'quantity',
        'vendor',
        'partNumber',
        'outputVoltage'
    ],
    lc_voltage_regulator_device: [
        'device',
        'vendor',
        'partNumber',
        'outputVoltage'
    ],
    fsync_signal: [
        'item',
        'interfaceFrequency',
        'vendor',
        'partNumber'
    ],
    pwm: [
        'portNumber',
        'interfaceFrequency',
        'vendor',
        'partNumber'
    ],
    uart: [
        'portNumber',
        'interfaceFrequency',
        'vendor',
        'partNumber'
    ],
    peripheral_interfaces_can: [
        'portNumber',
        'canMode',
        'vendor',
        'partNumber'
    ],
    thermal_interface_material_detail: [
        'layer',
        'materialDetails',
        'bondlineThickness',
        'timThickness',
        'dispensingPattern',
        'volume'
    ],
    cpu_root_port: [
        'portNumber',
        'portConfiguration'
    ],
    mgx_bay_type: [
        'bayType',
        'bayCount'
    ]
}
